import { TripFolderMissionInput } from '../../lib/types/models/trip-folder/trip-folder-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function assignMissionToTripFolder(id: number, data: TripFolderMissionInput) {
  return restApiClient.url(constructApiUrl(API.tripFolder.assignMissions.url, { id })).post(data)
}
